<script lang="ts">
  import { fade } from "svelte/transition";
  import { api } from "./lib/api/index.js";
  import { cleanupLegacyStorage } from "./lib/persisted.js";
  import { router } from "./lib/router.svelte.js";
  import { library } from "./lib/stores/library.svelte.js";
  import { live } from "./lib/stores/live.svelte.js";
  import { playlists } from "./lib/stores/playlists.svelte.js";
  import { session } from "./lib/stores/session.svelte.js";
  import { ui } from "./lib/stores/ui.svelte.js";
  import ConfirmDialog from "./components/ConfirmDialog.svelte";
  import DocumentActions from "./components/DocumentActions.svelte";
  import PromptDialog from "./components/PromptDialog.svelte";
  import Shell from "./components/Shell.svelte";
  import Toasts from "./components/Toasts.svelte";
  import UploadDialog from "./components/UploadDialog.svelte";
  import LoginPage from "./pages/LoginPage.svelte";
  import Viewer from "./pages/Viewer.svelte";

  let bootError = $state("");

  $effect(() => {
    session.load().catch(() => (bootError = "Der Server ist gerade nicht erreichbar."));
  });

  // Nach dem Anmelden: Daten laden und Live-Verbindung öffnen; beim Abmelden alles leeren.
  $effect(() => {
    if (session.status === "ready" && session.user) {
      cleanupLegacyStorage();
      library.init(session.user.id);
      live.start();
      void live.refreshAll();
      return () => {
        live.stop();
        library.reset();
        playlists.reset();
      };
    }
  });

  const viewerMatch = $derived(router.match("/noten/:id"));

  // Seitenaufrufe für die Statistik (ohne personenbezogene Details)
  let lastTracked = "";
  $effect(() => {
    if (session.status !== "ready") return;
    const type = viewerMatch
      ? "viewer"
      : router.path.startsWith("/setlists")
        ? "playlists"
        : router.path.startsWith("/verwaltung")
          ? "admin"
          : "library";
    if (type === lastTracked) return;
    lastTracked = type;
    void api.pageView(type).catch(() => undefined);
  });
</script>

{#if session.status === "loading"}
  <div class="splash" out:fade={{ duration: 200 }}>
    {#if bootError}
      <p>{bootError}</p>
      <button type="button" class="btn btn-ghost" onclick={() => location.reload()}>Erneut versuchen</button>
    {:else}
      <span class="pulse" aria-label="Lädt"></span>
    {/if}
  </div>
{:else if session.status === "anonymous"}
  <LoginPage />
{:else}
  <Shell />
  {#if viewerMatch}
    {#key viewerMatch.id}
      <Viewer documentId={viewerMatch.id ?? ""} />
    {/key}
  {/if}
  {#if ui.actionsFor}
    <DocumentActions documentId={ui.actionsFor} />
  {/if}
  {#if ui.uploadOpen}
    <UploadDialog />
  {/if}
{/if}

<ConfirmDialog />
<PromptDialog />
<Toasts />

<style>
  .splash {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    color: var(--text-2);
  }
  .pulse {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: var(--accent);
    animation: breathe 1.2s var(--ease-out) infinite alternate;
  }
  @keyframes breathe {
    from {
      transform: scale(0.85);
      opacity: 0.5;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
